import * as React from 'react';
import { useTrackedPointer } from '../utils/useTrackedPointer';
export function useSuggestMouseEvents(setSelectedItemIndex) {
  const {
    wasPointerMoved,
    pointerUpdate
  } = useTrackedPointer();
  const onMouseMove = React.useCallback(index => e => {
    if (wasPointerMoved(e)) {
      setSelectedItemIndex(index);
    }
  }, [setSelectedItemIndex, wasPointerMoved]);
  const onMouseLeave = React.useCallback(e => {
    if (wasPointerMoved(e)) {
      setSelectedItemIndex(undefined);
    }
  }, [setSelectedItemIndex, wasPointerMoved]);
  const onMouseEnter = React.useCallback(e => {
    pointerUpdate(e);
  }, [pointerUpdate]);
  return {
    onMouseMove,
    onMouseEnter,
    onMouseLeave
  };
}